import React from 'react';
import { TX_NO_DATA } from 'src/storybook_transifex';
import { Typography } from './Typography';

export const NO_DATA = <Typography type="secondary">{TX_NO_DATA}</Typography>;
